
@if(initialLoading()) {
  <div></div>
}
@else {
  @if(!orders().length) {
    <equine-ui-nx-empty-cart
    [hasPending]="hasBraintreeVerifications()"
    (clicked)="goToDashboard()"
    (verificationClicked)="goToAccountVerificationView()"
    ></equine-ui-nx-empty-cart>
  }
  @else {
    <div class="container">
      <div class="row justify-content-center my-4">
    
        <div class="col-12 col-md-8">
          <div class="row rounded pb-3">
            @if(orders()) {
              <equine-ui-nx-shopping-cart
              [orders]="orders()"
              [total]="subTotal()"
              [subtotalItems]="totalItems()"
              [isAdmin]="isAdmin"
              (removeOrderFromCart)="removeOrderFromCart($event)"
            ></equine-ui-nx-shopping-cart>
            }
          </div>
    
          <div class="row rounded pb-3">
            <div class="col-12 col-md-4">
              <equine-ui-nx-coupon-code
                [disabled]="!couponAndDonationSectionsEnabled()"
                (couponApplied)="onCouponApplied($event)"
              ></equine-ui-nx-coupon-code>
            </div>
            <div class="col-12 col-md-4">
              <equine-ui-nx-donation
                [donationOrder]="donationOrder()"
                [disabled]="!couponAndDonationSectionsEnabled()"
                (addDonation)="addDonation($event)"
                (removeDonation)="removeDonation()"
              ></equine-ui-nx-donation>
            </div>
            <div class="col-12 col-md-4">
              <equine-ui-nx-payment-type
                (checked)="setPaymentType($event)"
              ></equine-ui-nx-payment-type>
            </div>
          </div>
        </div>
    
        <div class="col-12 col-md-4">
          <equine-ui-nx-cart-totals
            [subtotal]="subTotal()"
            [subtotalCount]="totalItems()"
            [coupon]="coupon()"
            [donation]="donationOrderTotal()"
            [total]="total()"
            (checkout)="proceedToCheckout()"
          ></equine-ui-nx-cart-totals>
        </div>
    
      </div>
    </div>
  
  }

}
